<template>
  <div>
    <el-form
      ref="formData"
      :model="formData"
      :rules="rules"
      label-position="top"
    >
      <div class="d-flex">
        <div>
          <span style="font-size: 14px; color: #606266"
            >客户名称：{{ formData.custShortName }}</span
          >
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266"
            >总件数：{{ formData.totQty }} 件</span
          >
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266"
            >支出：{{ formData.totPayWeight }}kg
            {{ formData.totPayVolume }}m³</span
          >
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266"
            >收入：{{ formData.totInWeight }}kg
            {{ formData.totInVolume }}m³</span
          >
          <el-divider direction="vertical"></el-divider>
          <span style="font-size: 14px; color: #606266">拆成</span>
        </div>
        <div>
          <el-input-number
            v-model="splitNum"
            size="mini"
            controls-position="right"
            :min="2"
            :max="99"
            class="ml-2"
            style="width:90px;"
          >
          </el-input-number>
          <span class="ml-2" style="font-size: 14px; color: #606266">单</span>
          <el-button
            slot="append"
            class="ml-2"
            size="mini"
            type="success"
            @click="splitBill"
            >拆单</el-button
          >
        </div>
      </div>
      <el-row :gutter="10">
        <el-col :span="6">
          <el-form-item
            label="计划提货开始时间"
            prop="pickDatetimeBegin"
            size="mini"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.pickDatetimeBegin"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择提货日期"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="计划提货截止时间"
            prop="pickDatetimeEnd"
            size="mini"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.pickDatetimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择计划提货截止时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="计划送达开始时间"
            prop="receiveDatetimeBegin"
            size="mini"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.receiveDatetimeBegin"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择计划送达开始时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
        <el-col :span="6">
          <el-form-item
            label="计划送达截止时间"
            prop="receiveDatetimeEnd"
            size="mini"
          >
            <el-date-picker
              style="width:100%"
              v-model="formData.receiveDatetimeEnd"
              value-format="yyyy-MM-dd HH:mm:ss"
              type="datetime"
              placeholder="选择计划送达截止时间"
            >
            </el-date-picker>
          </el-form-item>
        </el-col>
      </el-row>
      <goods-table ref="orderGoods" :tableData="goodsList" />
      <div class="side-frame">拆单详情</div>
      <split-table ref="splitGoods" :listData="splitGoodsList" class="mt-2" />
    </el-form>
    <div class="dialog-footer mt-3 d-flex justify-content-end">
      <el-button @click="close()" size="small">
        取消
      </el-button>
      <el-button type="primary" @click="splitSumit" size="small"
        >确认提交拆量</el-button
      >
    </div>
  </div>
</template>
<script>
import Math from '@/libs/util.math.js'
export default {
  props: {
    formData: {
      type: Object,
      default: () => {},
    },
    disabled: {
      type: Boolean,
      default: false,
    },
  },
  components: {
    GoodsTable: () => import('./goods-table.vue'),
    SplitTable: () => import('./split-table.vue'),
  },
  data() {
    return {
      splitNum: 1,
      dialogOption: {
        title: '新增',
        dialogVisible: false,
      },
      goodsList: [],
      splitGoodsList: [],
      submitSplitOrderList: [],
      rules: {
        splitNum: [
          { required: true, message: '请输入分拆订单数量', trigger: 'blur' },
        ],
      },
    }
  },
  watch: {
    formData: {
      handler(formData) {
        if (formData) {
          this.load()
        }
      },
      immediate: true,
    },
  },
  methods: {
    load() {
      this.dialogOption.title =
        '订单拆量 | 原订单编号：' + this.formData.dispatchOrderNo
      this.dialogOption.dialogVisible = true
      let goodsJson = this.formData.goodsJson
      if (goodsJson !== '') {
        this.goodsList = JSON.parse(goodsJson)
      } else {
        this.goodsList = []
      }
    },
    async splitBill() {
      let params = {
        dispatchOrderCode: this.formData.dispatchOrderCode,
        splitNum: this.splitNum,
        goodsList: this.goodsList,
      }
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.splitGoodsList = []
      this.$api
        .bizDispatchPoolSplitBillTempApi(params)
        .then((res) => {
          loadingInstance.close()
          this.splitGoodsList = res.body.data
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    splitSumit() {
      if (this.splitGoodsList.length < 1) {
        return
      }

      const submitData = this.$refs.splitGoods.tableData

      // 验证提交的拆分数据
      let totQty = 0
      let totPayWeight = 0
      let totPayVolume = 0
      let totInWeight = 0
      let totInVolume = 0
      let totGoodsValue = 0

      this.goodsList.forEach((data) => {
        totQty = Math.add(Math.bignumber(totQty), Math.bignumber(data.goodsQty))
        totPayWeight = Math.add(
          Math.bignumber(totPayWeight),
          Math.bignumber(data.factWeight)
        )
        totPayVolume = Math.add(
          Math.bignumber(totPayVolume),
          Math.bignumber(data.factVolume)
        )
        totInWeight = Math.add(
          Math.bignumber(totInWeight),
          Math.bignumber(data.goodsWeight)
        )
        totInVolume = Math.add(
          Math.bignumber(totInVolume),
          Math.bignumber(data.goodsVolume)
        )
        totGoodsValue = Math.add(
          Math.bignumber(totGoodsValue),
          Math.bignumber(data.goodsValue)
        )
      })

      this.submitSplitOrderList = []
      let subTotQty = 0
      let subTotPayWeight = 0
      let subTotPayVolume = 0
      let subTotInWeight = 0
      let subTotInVolume = 0
      let subTotGoodsValue = 0

      for (let i = 0; i < this.splitNum; i++) {
        let splitGoodsList = []
        const childrenData = submitData[i].children
        let childrenTotQty = 0
        childrenData.forEach((goods) => {
          if (
            !parseInt(goods.goodsQty) &&
            (parseFloat(goods.factWeight) > 0 ||
              parseFloat(goods.factVolume) > 0 ||
              parseFloat(goods.goodsWeight) > 0 ||
              parseFloat(goods.goodsVolume) > 0)
          ) {
            this.$message.error(
              `调度订单【${goods.dispatchOrderNo}】货物件数为【0】却有重量体积，请检查`
            )
            throw new Error(
              `调度订单【${goods.dispatchOrderNo}】货物件数为【0】却有重量体积，请检查`
            )
          }
          if (parseInt(goods.goodsQty)) {
            childrenTotQty = Math.add(
              Math.bignumber(childrenTotQty),
              Math.bignumber(goods.goodsQty)
            )
            subTotQty = Math.add(
              Math.bignumber(subTotQty),
              Math.bignumber(goods.goodsQty)
            )
            subTotPayWeight = Math.add(
              Math.bignumber(subTotPayWeight),
              Math.bignumber(goods.factWeight)
            )
            subTotPayVolume = Math.add(
              Math.bignumber(subTotPayVolume),
              Math.bignumber(goods.factVolume)
            )
            subTotInWeight = Math.add(
              Math.bignumber(subTotInWeight),
              Math.bignumber(goods.goodsWeight)
            )
            subTotInVolume = Math.add(
              Math.bignumber(subTotInVolume),
              Math.bignumber(goods.goodsVolume)
            )
            subTotGoodsValue = Math.add(
              Math.bignumber(subTotGoodsValue),
              Math.bignumber(goods.goodsValue)
            )
            splitGoodsList.push(goods)
          }
        })

        if (!childrenTotQty) {
          this.$message.error(
            `调度订单【${childrenData[0].dispatchOrderNo}】货物总件数为【${childrenTotQty}】不能进行拆单，请检查`
          )
          throw new Error(
            `调度订单【${childrenData[0].dispatchOrderNo}】货物总件数为【${childrenTotQty}】不能进行拆单，请检查`
          )
        }
        const splitItem = {
          dispatchOrderCode: childrenData[0].dispatchOrderCode,
          dispatchOrderNo: childrenData[0].dispatchOrderNo,
          originOrderCode: childrenData[0].originOrderCode,
          originOrderNo: childrenData[0].originOrderNo,
          list: splitGoodsList,
        }
        this.submitSplitOrderList.push(splitItem)
      }
      if (!subTotQty.equals(totQty)) {
        this.$message.error('拆单货物总件数与原订单货物件数不等，请检查')
        return
      }
      if (!subTotPayWeight.equals(totPayWeight)) {
        this.$message.error('拆单总支出重量与原订单支出重量不等,请检查')
        return
      }
      if (!subTotPayVolume.equals(totPayVolume)) {
        this.$message.error('拆单总支出体积与原订单支出体积不等，请检查')
        return
      }
      if (!subTotInWeight.equals(totInWeight)) {
        this.$message.error('拆单总收入重量与原订单收入重量不等，请检查')
        return
      }
      if (!subTotInVolume.equals(totInVolume)) {
        this.$message.error('拆单总收入体积与原订单收入体积不等，请检查')
        return
      }
      if (!subTotInVolume.equals(totInVolume)) {
        this.$message.error('拆单总收入体积与原订单收入体积不等，请检查')
        return
      }
      if (!subTotGoodsValue.equals(totGoodsValue)) {
        this.$message.error('拆单总货值与原订单货值不等，请检查')
        return
      }

      const params = {
        list: this.submitSplitOrderList,
      }
      this.submitSave(params)
    },
    submitSave(params) {
      let loadingInstance = this.$loading({
        lock: true,
        text: 'Loading',
        spinner: 'el-icon-loading',
        background: 'rgba(0, 0, 0, 0.7)',
      })
      this.$api
        .bizDispatchPoolSplitSubmitApi(params)
        .then(() => {
          loadingInstance.close()
          this.saveOk()
        })
        .catch(() => {
          loadingInstance.close()
        })
    },
    close() {
      this.$emit('close')
    },
    saveOk() {
      this.$emit('saveOk')
    },
  },
}
</script>
<style lang="scss" scoped>
.line {
  text-align: center;
}
.side-frame {
  padding: 1px 10px;
  border-left: 3px solid $color-primary;
  margin: 15px 0;
}
.side-frame-success {
  padding: 1px 10px;
  border-left: 3px solid $color-success;
  margin: 15px 0;
}
.group-title {
  font-size: 16px;
  font-weight: 500;
  color: #606266;
}
</style>
